import React, { createContext, useContext, useEffect, useState } from "react" 
import { queryTools, cn, sortArrayOfObjects } from "lib/utils";
import { Dropdown } from "lib/components"
import { useRulesEngineCtx } from "."
import { update } from "lodash";

const operators = [
  { label: "Must Equal", value: "eq" },
  { label: "Must Not Equal", value: "neq" },
  { label: "Must Contain", value: "contains" },
  { label: "Must Not Contain", value: "notcontains" },
  { label: "Must Exist", value: "exists" },
  { label: "Must Not Exist", value: "notexists" },
]

export default function RulesFilterArea(){

  const { engineState, updateEngineState } = useRulesEngineCtx()
  
  const { data:_Rules } = queryTools.resource.parseQueryForApi("rule.findAll", { location: engineState.selectedSection?.refstr }, { enabled: !!engineState.selectedSection?.refstr })
  const { data:_Rule } = queryTools.resource.parseQueryForApi("rule.findById", { _id: engineState.selectedRule?._id }, { enabled: !!engineState.selectedRule?._id })
  
  const getUniqueSubdomains = (rules:any[]) => {
    const uniqueSubdomains = new Set()
    rules.forEach((rule:any) => {
      if( rule.subdomain ) uniqueSubdomains.add(rule.subdomain)
    })
    let arr = Array.from(uniqueSubdomains).map( (subd:any) => ({ label: subd, value: subd }) )
    return sortArrayOfObjects(arr, "value")
  }

  const getUniqueRpIdsBySubdomain = (rules:any[], subdomain:string) => {
    const uniqueRpIds = new Set()
    rules.forEach((rule:any) => rule.subdomain === subdomain && rule.rpid && uniqueRpIds.add(rule.rpid) )
    let arr = Array.from(uniqueRpIds).map( (subd:any) => ({ label: subd, value: subd }) )
    return sortArrayOfObjects(arr, "label")
  }

  useEffect(() => {
    console.log(engineState.selectedRule)
  },[engineState.selectedRule])

  useEffect(() => {
    if( engineState.selectedRpid ) {
      const rules = _Rules.filter((rule:any) => rule.location === engineState.selectedSection?.refstr && rule.subdomain === engineState.selectedSubdomain && rule.rpid === engineState.selectedRpid)
      updateEngineState("matchingRules", rules)
    }
  },[engineState.selectedRpid])

  useEffect(() => {
    if( engineState.selectedSubdomain && _Rules && _Rules.length > 0 ){
      const rpids = getUniqueRpIdsBySubdomain(_Rules, engineState.selectedSubdomain)
      console.log("rpids", rpids)
      updateEngineState("rpids", rpids)
    }
  },[engineState.selectedSubdomain, _Rules])

  useEffect(() => {
    if( _Rules && _Rules.length > 0 ){
      const uniqueSubdomains = getUniqueSubdomains(_Rules)
      updateEngineState("subdomains", uniqueSubdomains)
    }
  },[_Rules])

  return (
    <div className="w-full flex flex-col">
      
      <div className="flex items-center px-2 py-1 bg-slate-800 border-b border-solid border-slate-700 text-sm">
        { engineState.selectedSection?.title }
      </div>
            
      <div className="w-full flex flex-col">
        <div className="w-full flex justify-start items-center px-3 py-2 gap-3">
          <Dropdown
            className="w-6/12 bg-slate-900"
            title="Choose a Subdomain"
            placeholder="Choose a Subdomain"
            items={engineState.subdomains}
            selected={engineState.selectedSubdomain}
            selectFn={(item:any) => {
              console.log(item)
              updateEngineState("selectedSubdomain", item.value)
            }}
          />
          { engineState.selectedSubdomain !== null && (
            <Dropdown
              className="w-6/12 bg-slate-900"
              title="Choose an RP"
              placeholder="Choose a RP"
              items={engineState.rpids}
              selected={engineState.selectedRpid}
              selectFn={(item:any) => {
                console.log(item)
                updateEngineState("selectedRpid", item.value)
              }}
            />
          )}
        </div>
      </div>

      { engineState.matchingRules && engineState.matchingRules.length > 0 && (
        <div className="w-full flex flex-col items-stretch px-3 py-2">
          <div className="w-full flex items-center bg-slate-700 text-xs uppercas px-2 py-1">Matching Rules</div>
          <div className="w-full flex flex-col border border-solid border-slate-700">
            { engineState.matchingRules.map((rule:any, idx:number) => (
              <div 
                key={rule._id} 
                className="px-2 py-1 cursor-default hover:bg-slate-800 hover:text-white"
                onClick={() => updateEngineState("selectedRule", {...rule, _id: rule._id, location: engineState.selectedSection.refstr, subdomain: engineState.selectedSubdomain, rpid: engineState.selectedRpid})}
              >
                <h5 className="text-base font-semibold text-teal-800">{ rule.rule.name } </h5>
                <p className="text-sm italic">{ rule.rule.description }</p>
              </div>
            ))}
          </div>
        </div>
      )}

    </div>
  )
}